import * as FiIcons from 'react-icons/fi';
import * as BsIcons from 'react-icons/bs';
import * as RiIcons from 'react-icons/ri';

export const content = {
  profile: {
    name: "Maries Villarosa",
    title: "Senior Executive in Banking Delivery & PMO Transformation",
    tagline: "Designing and scaling enterprise PMOs for global financial institutions.",
    bio: "Maries Villarosa is a distinguished Subject Matter Expert in banking delivery, PMO build-out, and regulatory transformation. With a career spanning top-tier financial hubs in Europe and Asia, she specializes in establishing robust governance frameworks, optimizing portfolio controls, and leading high-stakes regulatory programs. Maries partners with C-suite executives to translate strategic vision into operational reality, ensuring delivery excellence across complex, multi-jurisdictional landscapes.",
    image: "https://media-manager-c.questera.ai/greta-media/29a20af30bd50f0331d2a32e8bab2d926b9f480b7a7f7fa86d6a5fc65541d424101393f9afc6e1f60f8b008209294a43/images/aW1hZ2UvcG5n/51635fc366461ce95c18ed850befb371.png"
  },
  expertise: [
    {
      title: "PMO Build-out & Scale",
      description: "Architecting centralized and federated PMO structures that align with enterprise strategy. Expert in setting up Centre of Excellence (CoE) models.",
      icon: FiIcons.FiLayers
    },
    {
      title: "Regulatory Transformation",
      description: "Leading critical regulatory change programs (e.g., Basel, MiFID, ESG) ensuring full compliance and operational resilience across borders.",
      icon: BsIcons.BsBank
    },
    {
      title: "Portfolio Governance",
      description: "Implementing rigorous stage-gate controls, investment committees, and benefits realization frameworks to maximize ROI.",
      icon: RiIcons.RiGovernmentLine
    },
    {
      title: "Delivery Excellence",
      description: "Standardizing delivery methodologies (Agile, Waterfall, Hybrid) to improve velocity, quality, and predictability of execution.",
      icon: FiIcons.FiTrendingUp
    }
  ],
  highlights: [
    {
      role: "Global Head of PMO Transformation",
      context: "Tier 1 Global Bank (London/Singapore)",
      description: "Led the consolidation of regional PMOs into a single global function, reducing operational costs by 20% while improving reporting transparency for the ExCo."
    },
    {
      role: "Program Director - Regulatory Change",
      context: "Pan-Asian Banking Group",
      description: "Delivered a multi-year regulatory remediation program across 7 markets, achieving 100% compliance ahead of regulatory deadlines."
    },
    {
      role: "Strategic Advisor",
      context: "Fintech Partnership Integration",
      description: "Designed the governance framework for a high-value integration between a legacy bank and a disruptive fintech partner."
    }
  ],
  advisory: {
    title: "The Future of Banking Delivery",
    text: "In an era of rapid digital disruption, the traditional PMO must evolve from a reporting function to a strategic enabler. My approach focuses on 'Adaptive Governance'—controls that are rigorous enough to manage risk but flexible enough to support innovation."
  },
  contact: {
    email: "maries@villarosa.tech",
    linkedin: "https://linkedin.com/in/maries-villarosa-pmp",
    location: "Global / Available for International Engagements"
  }
};